import React, { useState } from "react";
import { BadgeCheck, Upload, Loader2 } from "lucide-react";
import api from "../lib/api";

const Brokers = () => {
  const [tab, setTab] = useState("apply");
  const [apply, setApply] = useState({ company: "", contact_name: "", email: "", phone: "", mc_number: "", notes: "" });
  const [loadPost, setLoadPost] = useState({ company: "", email: "", mc_number: "", origin: "", destination: "", equipment: "Dry Van", rate: "", notes: "" });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submitApply = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg("");
    try {
      await api.post("/brokers/apply", apply);
      setMsg("Application received! We'll verify your MC authority and reach out. Once verified, you can post loads.");
      setApply({ company: "", contact_name: "", email: "", phone: "", mc_number: "", notes: "" });
    } catch (err) { setMsg("Something went wrong. Please try again."); }
    finally { setBusy(false); }
  };

  const submitLoad = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg("");
    try {
      await api.post("/brokers/loads", loadPost);
      setMsg("Load submitted! Our team will review and post it to the board.");
      setLoadPost({ company: "", email: "", mc_number: "", origin: "", destination: "", equipment: "Dry Van", rate: "", notes: "" });
    } catch (err) {
      setMsg(err?.response?.data?.detail || "Could not submit load.");
    } finally { setBusy(false); }
  };

  return (
    <section className="brokers" id="brokers">
      <div className="container">
        <div className="section-head">
          <span className="kicker">For Brokers</span>
          <h2>Verified brokers, post your loads</h2>
          <p>Get verified once, then submit your freight directly to our dispatch team to be posted on the board.</p>
        </div>

        <div className="broker-tabs">
          <button className={tab === "apply" ? "on" : ""} onClick={() => { setTab("apply"); setMsg(""); }}><BadgeCheck size={16} /> Get Verified</button>
          <button className={tab === "post" ? "on" : ""} onClick={() => { setTab("post"); setMsg(""); }}><Upload size={16} /> Post a Load</button>
        </div>

        <div className="broker-card">
          {msg && <div className="broker-msg">{msg}</div>}
          {tab === "apply" ? (
            <form onSubmit={submitApply} className="broker-form">
              <div className="form-row">
                <div className="field"><label>Company</label><input required value={apply.company} onChange={(e) => setApply({ ...apply, company: e.target.value })} placeholder="Summit Brokers LLC" /></div>
                <div className="field"><label>Contact Name</label><input required value={apply.contact_name} onChange={(e) => setApply({ ...apply, contact_name: e.target.value })} placeholder="John Broker" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>Email</label><input type="email" required value={apply.email} onChange={(e) => setApply({ ...apply, email: e.target.value })} placeholder="you@company.com" /></div>
                <div className="field"><label>Phone</label><input required value={apply.phone} onChange={(e) => setApply({ ...apply, phone: e.target.value })} placeholder="(555) 555-5555" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>MC Number</label><input required value={apply.mc_number} onChange={(e) => setApply({ ...apply, mc_number: e.target.value })} placeholder="MC-123456" /></div>
                <div className="field"><label>Notes</label><input value={apply.notes} onChange={(e) => setApply({ ...apply, notes: e.target.value })} placeholder="Lanes / freight types" /></div>
              </div>
              <button className="btn btn-primary btn-block" disabled={busy}>{busy ? <Loader2 size={16} className="spin" /> : <BadgeCheck size={16} />} Apply for Verification</button>
            </form>
          ) : (
            <form onSubmit={submitLoad} className="broker-form">
              <p className="broker-hint">Verified brokers only — enter the email &amp; MC number you were verified with.</p>
              <div className="form-row">
                <div className="field"><label>Company</label><input required value={loadPost.company} onChange={(e) => setLoadPost({ ...loadPost, company: e.target.value })} placeholder="Summit Brokers LLC" /></div>
                <div className="field"><label>Verified Email</label><input type="email" required value={loadPost.email} onChange={(e) => setLoadPost({ ...loadPost, email: e.target.value })} placeholder="you@company.com" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>MC Number</label><input required value={loadPost.mc_number} onChange={(e) => setLoadPost({ ...loadPost, mc_number: e.target.value })} placeholder="MC-123456" /></div>
                <div className="field"><label>Equipment</label><input value={loadPost.equipment} onChange={(e) => setLoadPost({ ...loadPost, equipment: e.target.value })} placeholder="Dry Van" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>Origin</label><input required value={loadPost.origin} onChange={(e) => setLoadPost({ ...loadPost, origin: e.target.value })} placeholder="Chicago, IL" /></div>
                <div className="field"><label>Destination</label><input required value={loadPost.destination} onChange={(e) => setLoadPost({ ...loadPost, destination: e.target.value })} placeholder="Dallas, TX" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>Rate</label><input required value={loadPost.rate} onChange={(e) => setLoadPost({ ...loadPost, rate: e.target.value })} placeholder="$2,450" /></div>
                <div className="field"><label>Notes</label><input value={loadPost.notes} onChange={(e) => setLoadPost({ ...loadPost, notes: e.target.value })} placeholder="Pickup date, commodity..." /></div>
              </div>
              <button className="btn btn-primary btn-block" disabled={busy}>{busy ? <Loader2 size={16} className="spin" /> : <Upload size={16} />} Submit Load</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Brokers;
